import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Speakers = () => {
  const [speakers, setSpeakers] = useState([]);

  useEffect(() => {
    axios.get(`${API}/speakers`).then((r) => setSpeakers(r.data)).catch(console.error);
  }, []);

  return (
    <section id="speakers" data-testid="speakers-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <span className="section-label">Speakers</span>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tighter text-white mt-4 mb-4 max-w-2xl">
          Learn from the <span className="gradient-text">best minds</span> in tech
        </h2>
        <p className="text-zinc-400 text-base sm:text-lg mb-16 max-w-xl leading-relaxed">
          Industry leaders, innovators, and experts sharing insights on AI, digital transformation, and the future of technology in Africa.
        </p>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 stagger-children">
          {speakers.map((speaker, index) => (
            <div
              key={speaker.id}
              className={`speaker-card bg-zinc-900 border border-zinc-800 overflow-hidden ${
                index === 0 ? "sm:col-span-2 lg:col-span-1" : ""
              }`}
              data-testid={`speaker-card-${speaker.id}`}
            >
              <div className="aspect-[4/3] overflow-hidden bg-zinc-800">
                <img
                  src={speaker.image}
                  alt={speaker.name}
                  className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-white tracking-tight">{speaker.name}</h3>
                <p className="text-teal-400 text-sm font-medium mt-1">{speaker.role}</p>
                <p className="text-zinc-500 text-sm mt-3 leading-relaxed">{speaker.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Speakers;
